// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__XEXoC","choiceBoxes":"toolbarselects_choiceBoxes__3mQlr","simpleField":"toolbarselects_simpleField__1n4EW"};